import { useQuery, gql } from '@apollo/client'
import { Box, Text, Skeleton, HStack, useColorModeValue } from '@chakra-ui/react'
import { kindLabels } from './donaHelpersAI.jsx'

const totalsByKindQuery = gql`
  query {
    gqDonaTotalsByKind {
      global { totalUsd count }
      byKind { kind totalUsd count }
    }
  }
`

export const CategoryTotal = ({kind}) => {
  const {data, loading, error} = useQuery(totalsByKindQuery)

  if (error) return null

  const totals = data?.gqDonaTotalsByKind
  const globalTotal = totals?.global?.totalUsd ?? 0
  const categoryData = totals?.byKind?.find(k => k.kind === kind)
  const categoryTotal = categoryData?.totalUsd ?? 0
  const categoryLabel = kindLabels[kind] || kind

  return (
    <HStack justify="center" spacing={8} p={4} bg={useColorModeValue('gray.100', 'gray.700')} borderRadius="md">
      <Box textAlign="center">
        <Text as={/** @type {any} */ (loading && Skeleton)} fontWeight="bold" fontSize="xl" minW="80px">${globalTotal.toFixed(2)}</Text>
        <Text fontSize="sm">Total Donated</Text>
      </Box>
      {kind && (
        <Box textAlign="center">
          <Text as={/** @type {any} */ (loading && Skeleton)} fontWeight="bold" fontSize="xl" minW="80px">${categoryTotal.toFixed(2)}</Text>
          <Text fontSize="sm">{categoryLabel}</Text>
        </Box>
      )}
    </HStack>
  )
}
